import { render, staticRenderFns } from "./ResultsQuadrant.vue?vue&type=template&id=06f44d74&"
import script from "./ResultsQuadrant.vue?vue&type=script&lang=js&"
export * from "./ResultsQuadrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports